import { render, staticRenderFns } from "./duration.vue?vue&type=template&id=07ae4f98&"
import script from "./duration.vue?vue&type=script&lang=js&"
export * from "./duration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports